import React from 'react';
import NumericKeyboard from '@/components/NumericKeyboard';
import { PaymentChannel } from '@/models/payment';
import styles from '../style.less';
import { RedEnvelopeOutlined } from '@ant-design/icons';
import { useSettlementStore } from '../store/useSettlementStore';

/**
 * 直收模式（无商品清单，直接录入交易金额）的待收款键盘区域
 */
const DirectTradeArea: React.FC = () => {
  const actualPrice = useSettlementStore(s => s.actualPrice);
  const setActualPrice = useSettlementStore(s => s.setActualPrice);
  const setPaymentChannel = useSettlementStore(s => s.setPaymentChannel);

  return (
    <div className={styles.item}>
      <h3>
        <RedEnvelopeOutlined /> 待收款金额
      </h3>
      <NumericKeyboard
        value={actualPrice ? actualPrice.toNumber() : undefined}
        placeholder={'请输入待收款金额'}
        parseValueToNumber
        precision={2}
        onChange={(val) => {
          setActualPrice(val);
          if (!val) {
            setPaymentChannel(PaymentChannel.Online);
          }
        }}
      />
    </div>
  );
};

export default DirectTradeArea;
